import React from "react";
import { motion } from "framer-motion";
import { Printer, Droplets, Wrench } from "lucide-react";

const SERVICES = [
  {
    icon: Droplets,
    title: "Tinteiros e Toners",
    description: "Soluções originais, compatíveis e recicladas, selecionadas de acordo com cada equipamento e volume de impressão. Analisamos cada caso e aconselhamos a opção mais económica, preservando sempre a fiabilidade e o bom funcionamento das impressoras.",
    accent: "#00AEEF",
  },
  {
    icon: Printer,
    title: "Consumíveis de Impressão",
    description: "Papel A4 de 75 g ou 80 g, escolhido em função da área de trabalho e da qualidade exigida por cada negócio. Fornecemos também formatos especiais, papel para plotters e rolos de papel térmico para terminais de pagamento e impressão de talões.",
    accent: "#EC008C",
  },
  {
    icon: Wrench,
    title: "Reparação de Impressoras",
    description: "Serviço de diagnóstico e reparação para diferentes tipos de impressoras. Identificamos a origem da avaria e aconselhamos a solução mais adequada, ajudando a prolongar a vida útil do equipamento e a evitar substituições desnecessárias.",
    accent: "#FF7F00",
  },
];

export default function Services() {
  return (
    <section id="servicos" className="relative py-24 lg:py-32 bg-background" data-testid="services-section">
      <div className="absolute inset-0 bg-grid-soft opacity-40 pointer-events-none" />
      <div className="relative w-full px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground font-semibold mb-4">
              Serviços
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-foreground tracking-tight leading-[1.05]" data-testid="services-title">
              O que <span className="cmyk-text">Fornecemos</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: idx * 0.05, ease: [0.2, 0.8, 0.2, 1] }}
                className={`eco-card group relative bg-card border border-border rounded-2xl p-7 lg:p-8 ${s.span || ""}`}
                data-testid={`service-card-${idx}`}
              >
                <div className="flex items-start mb-8">
                  <div className="h-12 w-12 rounded-xl flex items-center justify-center" style={{ background: `${s.accent}1f`, color: s.accent }}>
                    <Icon size={22} strokeWidth={2} />
                  </div>
                </div>
                <h3 className="font-display text-2xl font-semibold text-foreground mb-3 tracking-tight">{s.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{s.description}</p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
